import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone'
import { Dialog, DialogActions, DialogContent, Typography } from '@mui/material'

import Button from '@/components/componentLibrary/Button'

import { updateAvailable } from './utils'

const UpdateModal: FC = () => {
  const { t } = useTranslation()
  return (
    <Dialog open={updateAvailable} fullWidth maxWidth="sm">
      <Typography
        variant="h5"
        component="h2"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          fontWeight: 'bold',
          py: 2.5,
          px: 3,
        }}
      >
        <NotificationsNoneIcon sx={{ fontSize: 48, mb: 1 }} />
        {t('updateModal.header', 'Populus App Updated')}
      </Typography>
      <DialogContent>
        <Typography variant="h6" component="p">
          {t(
            'updateModal.content',
            'We have released a new version of the Populus App. Click OK to reload.'
          )}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          icon="Checkmark"
          text={t('updateModal.button', 'OK')}
          onClick={() => window.location.reload()}
        />
      </DialogActions>
    </Dialog>
  )
}

export default UpdateModal
